interface BugsnagEvent {
  context?: string;
  addMetadata: (section: string, values: Record<string, unknown>) => void;
}

interface BugsnagClient {
  isStarted?: () => boolean;
  notify: (error: Error, onError?: (event: BugsnagEvent) => void) => void;
}

declare global {
  interface Window {
    Bugsnag?: BugsnagClient;
  }
}

interface NotifyOptions {
  context?: string;
  metadata?: Record<string, unknown>;
}

// Bugsnag is started once by the Sprockets bundle (shared/bugsnag-js.coffee.erb).
// Importing @bugsnag/js inside a pack gives webpack its own copy of the module,
// whose client is never started, so its notify() only logs to the console.
const getClient = (): BugsnagClient | null => {
  const client = window.Bugsnag;

  if (!client || typeof client.notify !== 'function') return null;
  if (typeof client.isStarted === 'function' && !client.isStarted()) return null;

  return client;
};

export const notifyError = (error: unknown, options: NotifyOptions = {}): void => {
  const client = getClient();
  if (!client) return;

  const normalized = error instanceof Error ? error : new Error(String(error));

  try {
    client.notify(normalized, event => {
      if (options.context) event.context = options.context;
      if (options.metadata) event.addMetadata('custom', options.metadata);
    });
  } catch {
    // reporting must never break the caller
  }
};
